// src/api/linkedinFeedApi.js

const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://assocham.org/assocham_backend";

/**
 * Fetch LinkedIn organization posts.
 * @param {number} limit - max 100
 * @returns {Promise<Array>}
 */
export async function fetchLinkedInFeed(limit = 100) {
  const url = `${API_BASE}/api/linkedin/posts?limit=${encodeURIComponent(limit)}`;

  const res = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`LinkedIn fetch failed (${res.status}): ${text}`);
  }

  const json = await res.json();

  if (!json.success) {
    throw new Error(json.error || "LinkedIn API returned an error");
  }

  return json.posts || [];
}